import React, { useState } from 'react';

import { FiLogIn, FiMenu } from 'react-icons/fi';
import { GoTriangleUp } from 'react-icons/go';

import appIcon from 'assets/app_icon.png';
import { useUserData } from 'hooks/auth';

import DropDownMenu from './DropDownMenu';
import {
  Container,
  NavbarLeft,
  NavbarRight,
  NavbarLink,
  DropDownContainer,
  NavbarButton,
} from './styles';

const Navbar: React.FC = () => {
  const { user, userVerified, loading } = useUserData();

  const [menuIsOpen, setMenuIsOpen] = useState(false);

  return (
    <Container>
      <NavbarLeft>
        <NavbarLink to="/">
          <img src={appIcon} alt="Circle" style={{ width: '36px' }} />
          <div style={{ width: '12px' }} />
          <h1>Circle</h1>
        </NavbarLink>
      </NavbarLeft>
      <NavbarRight>
        {user ? (
          <DropDownContainer>
            <NavbarButton onClick={() => setMenuIsOpen(!menuIsOpen)}>
              {menuIsOpen ? <GoTriangleUp size={18} /> : <FiMenu size={18} />}
              <div style={{ width: '12px' }} />
              <p>Menu</p>
            </NavbarButton>
            <DropDownMenu
              user={user}
              userVerified={userVerified}
              isOpen={menuIsOpen}
              closeDropDown={() => setMenuIsOpen(false)}
            />
          </DropDownContainer>
        ) : loading ? (
          <></>
        ) : (
          <NavbarLink to="/signin">
            <FiLogIn size={18} />
            <div style={{ width: '12px' }} />
            <p>Entrar</p>
          </NavbarLink>
        )}
      </NavbarRight>
    </Container>
  );
};

export default Navbar;
